<mat-card *ngIf="currentCommunity" class="communicationCard">
    <mat-card-header>
        <mat-card-title>Communication Preferences</mat-card-title>
    </mat-card-header>
    <mat-card-content>

        <ng-container *ngIf="!currentCommunity?.communication_preferences">
            <p>
                By being a member of the {{ currentCommunity?.name }}, you have given consent to receiving
                transactional
                emails from the Community - as outlined in our Terms and Conditions and Privacy Policy.
            </p>
            <p>
                The receipt of these emails is important to help you keep up to date on the Community and its content.
            </p>
            <p>
                Although we'd be sad to see you go, if you no longer wish to receive emails from the Community then
                please
                delete your account by clicking 'leave the community' below.
            </p>
        </ng-container>
        <ng-container *ngIf="currentCommunity?.communication_preferences">
            <div [innerHTML]="currentCommunity?.communication_preferences_text_rendered" class="ck-editorControl"></div>
        </ng-container>

    </mat-card-content>
    <mat-card-actions *ngIf="isLoggedIn() && currentCommunity" class="flex-row flex-space-between">
        <button (click)="leave()" color="warn" mat-raised-button>Leave Community</button>
    </mat-card-actions>
    <mat-card-actions *ngIf="!isLoggedIn()" class="flex-row flex-space-between">
        <button [routerLink]="['/login']" color="primary" mat-raised-button>Login to manage communication preferences
        </button>
    </mat-card-actions>
</mat-card>
